module.exports = __webpack_public_path__ + "img/boton-02.021d998a.png";